import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  showDetails: { id: 'systemStatus.banner.showDetails' },
  hideDetails: { id: 'systemStatus.banner.hideDetails' },
  dismiss: { id: 'systemStatus.banner.dismiss' },
  more: { id: 'systemStatus.banner.more' },
  region: { id: 'systemStatus.banner.region' },
  pill: { id: 'systemStatus.banner.pill' },
  pillSingular: { id: 'systemStatus.banner.pillSingular' }
})
